import { SerializedContent } from '@/features/screenplay/components/editor/utils/JsonUtils'
import { create } from 'zustand'

export enum AIChatMode {
    create_scene = 'create_scene',
    edit_scene = 'edit_scene',
}

export type AIChatModeMeta = {
    title: string
    child: React.ReactNode
    promptPlaceholder: string
}

export const aIChatModeMetaData: Record<AIChatMode, AIChatModeMeta> = {
    [AIChatMode.create_scene]: {
        title: 'Craft a New Scene',
        child: undefined,
        promptPlaceholder: 'Describe the scene you want to create… a setting, a vibe, a moment.',
    },
    [AIChatMode.edit_scene]: {
        title: 'Reframe the Scene',
        child: undefined,
        promptPlaceholder: 'Tell us what to adjust — tone, pacing, dialogue, character intent…',
    },
}

interface SpAIWriterChatState {
    isDrawerOpen: boolean
    mode: AIChatMode
    inputNodes: SerializedContent[] | undefined
    outputNodes: SerializedContent[]
    setIsDrawerOpen: (isOpen: boolean) => void
    setOutputNodes: (nodes: SerializedContent[]) => void
    openDrawer: (mode: AIChatMode, inputNodes?: SerializedContent[]) => void
}

export const useSpAIWriterChatStore = create<SpAIWriterChatState>((set) => ({
    isDrawerOpen: false,
    mode: AIChatMode.create_scene,
    inputNodes: undefined,
    outputNodes: [],
    setIsDrawerOpen: (isOpen) => set({ isDrawerOpen: isOpen }),
    setOutputNodes: (nodes) => set({ outputNodes: nodes }),
    openDrawer: (mode, inputNodes) =>
        set({
            mode,
            inputNodes,
            outputNodes: [],
            isDrawerOpen: true,
        }),
}))
